import { injectable, inject } from "inversify";

import { PdfData } from "../entities/PdfData";
import { PdfStorageInterface } from "../interfaces/PdfStorageInterface";
import { Contexts, getContainer, NamedBindings, UserServiceInterface } from "@dandelion/core";
import { UserService } from "../services/UserService";

@injectable()
export class RESTPdfStorage implements PdfStorageInterface {
    protected headers: HeadersInit | undefined;
    protected userService: UserService;
    
    constructor(       
    ){
        this.userService = getContainer(Contexts.SHARED).get(NamedBindings.UserService) as UserService;
        this.headers = this.userService.getHeaders(); 
    }
    
    async getPdfPerCaseID(caseID: string, centreCode: string): Promise<PdfData[]> {
        return (await (
            await fetch(import.meta.env.VITE_APP_API_BASE_URL + `Report/${centreCode}/${caseID}`, {
                headers: this.headers,
                method: 'GET',
            })
        ).json()) as Array<PdfData>;
    }

    async saveCasePdf(visitReport: PdfData, caseID: string, headers?: Headers): Promise<void | Response> {
        if (headers) {
            return await this.saveSignedPdf(visitReport, caseID)
        } else {
            return await this.saveUnsignedPdf(visitReport, caseID)
        }
    }

    async saveSignedPdf(visitReport: PdfData, caseID: string, ) {
        return await fetch(import.meta.env.VITE_APP_API_BASE_URL + `Report/signAndSave/${visitReport.centreCode}/${caseID}/${visitReport.pdfUUID}/`, {
            headers: this.headers,
            body: visitReport.data,
            method: 'POST',
        });
    }

    async saveUnsignedPdf(visitReport: PdfData, caseID: string) {
        return await fetch(import.meta.env.VITE_APP_API_BASE_URL + `Report/printAndSave/${visitReport.centreCode}/${caseID}/${visitReport.pdfUUID}/`, {
            headers: this.headers,
            body: visitReport.data,
            method: 'POST',
        });
    }

    async cancelPdf(centreCode: string, caseID: string, pdfId: string) {
        return await fetch(import.meta.env.VITE_APP_API_BASE_URL + `Report/cancel/${centreCode}/${caseID}/${pdfId}`, {
            headers: this.headers,
            method: 'POST',
        });
    }
}
